import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'

import 'bootstrap/dist/css/bootstrap.min.css'
// import '@/styles/bootstrap.sass'
import '@/styles/index.scss'
// import '@/styles/markdown-github.sass'
import 'github-markdown-css/github-markdown-light.css'
import '@/styles/markdown.sass'

import '@/store/restore'
import '@/config/plugins'

import { github, gitee } from '@/config/count'

Vue.config.productionTip = false

const doCount = store => {
  if (store.state.site === 'gitee') gitee()
  else github()
}

new Vue({
  router,
  store,
  render: h => h(App),
  beforeMount () {
    doCount(this.$store)
  }
}).$mount('#app')
